<template>
    <div>
        <transition name="fade">
            <button v-show="show" @click="showInstallDialog" class="group to-amber-600 inline-flex items-center px-4 py-2 text-white text-sm font-semibold bg-gradient-to-br rounded-lg focus:outline-none shadow-md from-yellow-600 uppercase space-x-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="group-focus:text-amber-300 -ml-1 mr-1 w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                </svg>
                <span>Install App</span>
            </button>
        </transition>
    </div>
</template>

<script>
import JetButton from "@/Jetstream/Button"

export default {
    components: { JetButton },

    mounted() {
        window.addEventListener("beforeinstallprompt", (e) => this.loadButton(e))
    },

    destroyed() {
        window.removeEventListener("beforeinstallprompt", this.loadButton)
    },

    data() {
        return {
            show: false,
            deferredPrompt: null,
        }
    },

    methods: {
        loadButton(e) {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault()

            // Stash the event so it can be triggered later.
            this.deferredPrompt = e

            // Update UI notify the user they can add to home screen
            this.showButton()
        },

        showInstallDialog() {
            // hide our user interface that shows our A2HS button
            this.hideButton()

            // Show the prompt
            this.deferredPrompt.prompt()

            // Wait for the user to respond to the prompt
            this.deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === "accepted") {
                    console.log("User accepted the A2HS prompt")
                } else {
                    console.log("User dismissed the A2HS prompt")
                }
                this.deferredPrompt = null
            })
        },
        showButton() {
            this.show = true
        },

        hideButton() {
            this.show = false
        },
    },
}
</script>
